function ErrorService($translate, BBAlerts) {
    'ngInject';

    /**
     * @param {String} msg
     * @returns {{msg: String}}
     */
    const createCustomError = msg => ({msg});

    /***
     * @ngdoc method
     * @name getError
     * @methodOf BB.bbServices
     * @description
     * Returns error, always setting persist to true. Returns generic error if error with given key is not found.
     */
    const getError = (key) => {
        let error = getAlert(key);

        // return generic error if we can't find the key
        if (!error) {
            error = getAlert('GENERIC');
        }
        error.persist = true;
        return error;
    };

    /***
     * @ngdoc method
     * @name getAlert
     * @methodOf BB.bbServices
     * @description
     * Returns alert by given key
     */
    const getAlert = function (key, translationValue) {
        const alert = _.findWhere(BBAlerts, {key});

        if (alert) {
            alert.msg = $translate.instant(`CORE.ALERTS.${key}`, {value: translationValue});
            return alert;

        } else {
            return null;
        }
    };

    return {
        createCustomError,
        getAlert,
        getError
    };
}

angular
    .module('BB')
    .service('ErrorService', ErrorService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/error.service.js